// ------ image
export const HERO_IMAGE_BROKEN_DOCUMENT = 'broken-document';
export const HERO_IMAGE_CHEERING = 'cheering';
export const HERO_IMAGE_COMPLETE_SELLER_ACCOUNT = 'complete-seller-account';
export const HERO_IMAGE_CONFIRMATION = 'confirmation';
export const HERO_IMAGE_CROSSROAD = 'crossroad';
export const HERO_IMAGE_CROWN_THUMBS_UP = 'crowd-thumbs-up';
export const HERO_IMAGE_IN_THE_PROCESS = 'in-the-process';
export const HERO_IMAGE_LETTER_OPEN = 'letter-open';
export const HERO_IMAGE_SUCCESS_BARS = 'success-bars';
export const HERO_IMAGE_WORKERS = 'workers';


export const HERO_IMAGES = [
    HERO_IMAGE_BROKEN_DOCUMENT,
    HERO_IMAGE_CHEERING,
    HERO_IMAGE_COMPLETE_SELLER_ACCOUNT,
    HERO_IMAGE_CONFIRMATION,
    HERO_IMAGE_CROSSROAD,
    HERO_IMAGE_CROWN_THUMBS_UP,
    HERO_IMAGE_IN_THE_PROCESS,
    HERO_IMAGE_LETTER_OPEN,
    HERO_IMAGE_SUCCESS_BARS,
    HERO_IMAGE_WORKERS
];
